import { createFeatureSelector, createSelector } from '@ngrx/store';
import { kioskFeatureKey, KioskState } from './kiosk.reducer';

export const getKioskState = createFeatureSelector<KioskState>(kioskFeatureKey);
export const getWebsiteStarted = createSelector(getKioskState, (state) => state.websiteStarted);
export const getSysParamsloaded = createSelector(getKioskState, (state) => state.sysParamsLoaded);
